/*
PROV: COHINT001.BF.E2Q3H1A21F
REQ: SYS-ARCH-15
WHY: Frontend application module.
*/

export const SITE_PREFIX = "";

export function sitePath(href) {
  if (!href) return href;
  if (href.startsWith("http://") || href.startsWith("https://")) return href;
  if (href.startsWith("/")) return href;
  return `/${href}`;
}

